import React, { useState, useEffect } from 'react';

const API = 'https://talentflow-backend-production-09dd.up.railway.app/api';

export default function ApprovePage() {
  const id = new URLSearchParams(window.location.search).get('id');
  const [requirement, setRequirement] = useState(null);
  const [vendorBudget, setVendorBudget] = useState('');
  const [loading, setLoading] = useState(true);
  const [approving, setApproving] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) { setError('Invalid link'); setLoading(false); return; }
    fetch(`${API}/approval/${id}`)
      .then(r => r.json())
      .then(d => {
        if (d.success) { setRequirement(d.requirement); setVendorBudget(d.requirement.budget); }
        else setError(d.message);
        setLoading(false);
      }).catch(() => { setError('Server error'); setLoading(false); });
  }, []);

  const approve = async () => {
    if (!vendorBudget) return;
    setApproving(true);
    try {
      const r = await fetch(`${API}/approval/${id}/approve`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vendorBudget: Number(vendorBudget) })
      });
      const d = await r.json();
      if (d.success) setDone(true);
      else setError(d.message);
    } catch { setError('Error approving'); }
    setApproving(false);
  };

  const s = { fontFamily: '-apple-system,BlinkMacSystemFont,sans-serif', minHeight: '100vh', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' };

  if (loading) return <div style={s}><p style={{ color: '#64748b' }}>Loading...</p></div>;
  if (error) return <div style={s}><div style={{ background: 'white', padding: '40px', borderRadius: '12px', textAlign: 'center' }}><p style={{ color: '#ef4444' }}>{error}</p></div></div>;
  if (done) return (
    <div style={s}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '16px', textAlign: 'center', maxWidth: '480px', width: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <div style={{ fontSize: '56px', marginBottom: '16px' }}>🎉</div>
        <h2 style={{ color: '#1e293b', fontSize: '24px', fontWeight: '700', margin: '0 0 8px' }}>Approved Successfully!</h2>
        <p style={{ color: '#64748b', margin: '0 0 24px' }}>Requirement is now live. Vendors have been notified and client has been informed.</p>
        <a href="https://recruitment-frontend-beta.vercel.app" style={{ display: 'inline-block', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: 'white', padding: '12px 28px', borderRadius: '8px', textDecoration: 'none', fontWeight: '700' }}>Go to Dashboard →</a>
      </div>
    </div>
  );

  return (
    <div style={s}>
      <div style={{ background: 'white', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '560px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px' }}>
          <div style={{ width: '44px', height: '44px', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>⚡</div>
          <div>
            <h1 style={{ color: '#1e293b', fontSize: '20px', fontWeight: '800', margin: 0 }}>Review Requirement</h1>
            <p style={{ color: '#94a3b8', fontSize: '13px', margin: 0 }}>Skillora Admin Panel</p>
          </div>
        </div>

        {/* Requirement details */}
        <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '20px', marginBottom: '24px', border: '1px solid #e2e8f0' }}>
          <h2 style={{ color: '#1e293b', fontSize: '18px', fontWeight: '700', margin: '0 0 16px' }}>{requirement.title}</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
            {[
              ['👤 Client', requirement.client?.name],
              ['📧 Email', requirement.client?.email],
              ['💼 Experience', `${requirement.experience} years`],
              ['🛠 Skills', (requirement.skills || []).join(', ')],
              ['📝 Notice Period', requirement.noticePeriod || 'Not specified'],
            ].map(([label, value]) => (
              <div key={label}>
                <div style={{ color: '#94a3b8', fontSize: '11px', fontWeight: '600', marginBottom: '2px' }}>{label}</div>
                <div style={{ color: '#1e293b', fontSize: '14px', fontWeight: '500' }}>{value}</div>
              </div>
            ))}
          </div>
          {requirement.jobDescription && (
            <div>
              <div style={{ color: '#94a3b8', fontSize: '11px', fontWeight: '600', marginBottom: '4px' }}>📄 JOB DESCRIPTION</div>
              <p style={{ color: '#64748b', fontSize: '13px', lineHeight: '1.6', margin: 0 }}>{requirement.jobDescription}</p>
            </div>
          )}
        </div>

        {/* Budget section */}
        <div style={{ background: '#fff7ed', borderRadius: '12px', padding: '20px', marginBottom: '24px', border: '1px solid #fed7aa' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div>
              <div style={{ color: '#92400e', fontSize: '12px', fontWeight: '600' }}>CLIENT BUDGET (Confidential)</div>
              <div style={{ color: '#1e293b', fontSize: '28px', fontWeight: '800' }}>Rs.{requirement.budget?.toLocaleString()}</div>
            </div>
            <div style={{ fontSize: '32px' }}>💰</div>
          </div>
          <div>
            <label style={{ color: '#92400e', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>VENDOR BUDGET (What vendors will see)</label>
            <input
              type="number"
              value={vendorBudget}
              onChange={e => setVendorBudget(e.target.value)}
              placeholder="Enter vendor budget"
              style={{ width: '100%', padding: '12px 14px', background: 'white', border: '2px solid #f59e0b', borderRadius: '8px', color: '#1e293b', fontSize: '16px', fontWeight: '700', outline: 'none', boxSizing: 'border-box' }}
            />
            <p style={{ color: '#92400e', fontSize: '12px', margin: '6px 0 0' }}>💡 Vendors will NOT see the client budget — only this amount.</p>
          </div>
        </div>

        <button onClick={approve} disabled={approving || !vendorBudget}
          style={{ width: '100%', padding: '14px', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '16px', fontWeight: '700', fontFamily: 'inherit' }}>
          {approving ? 'Approving...' : '✅ Approve & Go Live'}
        </button>
      </div>
    </div>
  );
}
